import { useQuery } from '@tanstack/react-query'
import { useCurrentNetwork } from '@mysten/dapp-kit-react'

import { useBackendClient } from '@/shared/kai/contexts/BackendClientContext'

export const positionMetricsQueryKey = (network: string, positionId: string) =>
  ['position-metrics', network, positionId] as const

export const usePositionMetrics = (positionId: string) => {
  const network = useCurrentNetwork()

  const backendClient = useBackendClient()

  const result = useQuery({
    queryKey: positionMetricsQueryKey(network, positionId),
    queryFn: async () => {
      return await backendClient.getPositionMetrics(positionId)
    },
    staleTime: 1 * 60 * 1000, // 1 minute
    refetchInterval: 2 * 60 * 1000, // 2 minutes
  })

  return {
    isLoading: result.isLoading,
    isError: result.isError,
    data: result.data,
  }
}
